import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Trophy, Globe, Target, Zap} from 'lucide-react'

const atletas = [
  { name: "Atleta Patrocinado 1", sport: "MMA", desc: "Competidor internacional que representa a English Work em eventos globais, mostrando que o inglês abre portas no esporte mundial." },
  { name: "Atleta Patrocinado 2", sport: "Jiu-Jitsu", desc: "Campeão nacional que utiliza o inglês para competir e se comunicar em campeonatos internacionais." },
  { name: "Atleta Patrocinado 3", sport: "Surf", desc: "Atleta profissional que viaja o mundo e usa o inglês como ferramenta essencial na carreira esportiva." },
  { name: "Atleta Patrocinado 4", sport: "Skate", desc: "Representante da nova geração de atletas que entende a importância do idioma para a carreira internacional." },
]

const pilares = [
  { icon: Trophy, title: "Esporte e educação", text: "Unimos o esporte ao aprendizado de inglês, mostrando que disciplina e dedicação são valores universais." },
  { icon: Globe, title: "Visibilidade global", text: "Nossos atletas levam a marca English Work para competições e eventos ao redor do mundo." },
  { icon: Target, title: "Inspiração", text: "Cada atleta patrocinado inspira milhares de jovens a investirem na educação e no desenvolvimento pessoal." },
  { icon: Zap, title: "Superação", text: "Assim como no aprendizado de um idioma, o esporte exige prática constante, resiliência e evolução." },
]

export default function TimeAtletas() {
  const section1 = useScrollReveal()
  const section2 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Time de Atletas EW"
        subtitle="Conheça os atletas que representam a English Work e levam nossa missão para o mundo."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-14 leading-relaxed">
            A English Work acredita que o esporte e a educação caminham juntos. Nosso time de atletas patrocinados representa nossos valores de disciplina, superação e busca constante por evolução.
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            {atletas.map((item) => (
              <div
                key={item.name}
                className="rounded-2xl p-7 border border-gray-100 hover:shadow-lg transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-sm"
                    style={{ backgroundColor: "#B038B2" }}
                  >
                    <Trophy size={20} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900">{item.name}</h3>
                    <p className="text-xs font-semibold" style={{ color: "#0E8EA0" }}>{item.sport}</p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20" style={{ backgroundColor: "#F8F9FA" }}>
        <div
          ref={section2.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" style={{ color: "#0E8EA0" }}>
            Pilares do patrocínio
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {pilares.map((item) => (
              <div key={item.title} className="bg-white rounded-2xl p-6 border border-gray-100 text-center">
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4"
                  style={{ backgroundColor: "#0E8EA015" }}
                >
                  <item.icon size={26} style={{ color: "#0E8EA0" }} />
                </div>
                <h3 className="text-base font-bold mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
